// Shared colours for output charts and Quick Sizer resource bars.

/** Categorical palette for unordered series (doughnut slices). */
export const SEGMENT_PALETTE: readonly string[] = [
  'hsl(282, 43%, 54%)',
  'hsl(282, 44%, 62%)',
  'hsl(198, 0%, 34%)',
  'hsl(282, 100%, 24%)',
  'hsl(198, 100%, 34%)',
  'hsl(198, 0%, 87%)',
  'hsl(198, 0%, 19%)',
  'hsl(14, 87%, 78%)',
];

/** Colour for the nth series, wrapping when series outnumber colours. */
export function segmentColor(index: number): string {
  return SEGMENT_PALETTE[index % SEGMENT_PALETTE.length];
}

/** Amber overhead ramp, darkest first. Clarity ochre-800 … ochre-200. */
export const RESOURCE_OVERHEAD_RAMP: readonly string[] = [
  'hsl(37, 100%, 32%)',
  'hsl(38, 100%, 42%)',
  'hsl(39, 100%, 50%)',
  'hsl(40, 100%, 59%)',
  'hsl(41, 100%, 70%)',
  'hsl(41, 100%, 78%)',
  'hsl(41, 100%, 86%)',
];

/** What is left for workloads: usable capacity, available RAM, cores and IOPS. Clarity violet-600. */
export const RESOURCE_AVAILABLE_COLOR = 'hsl(282, 60%, 49%)';

/** Amber for the nth of `count` overheads, spread over the darker half of the ramp so neighbours stay apart. */
export function spreadOverheadColor(index: number, count: number): string {
  const lastStep = Math.min(4, RESOURCE_OVERHEAD_RAMP.length - 1);
  const step = count > 1 ? Math.round((index * lastStep) / (count - 1)) : 0;
  return RESOURCE_OVERHEAD_RAMP[Math.min(step, lastStep)];
}

/** VCF component reservations. Same colour on every Quick Sizer chart. */
export const RESOURCE_COMPONENT_COLOR = SEGMENT_PALETTE[4];

/** Every deduction on the capacity waterfall. Bar width shows size. */
export const RESOURCE_DEDUCTION_COLOR = RESOURCE_OVERHEAD_RAMP[2];

/** The data-reduction gain on the capacity waterfall. Clarity jade-700. */
export const RESOURCE_GAIN_COLOR = 'hsl(160, 64%, 30%)';

/** Subtotal rows on the capacity waterfall. Clarity construction-500. */
export const RESOURCE_ANCHOR_COLOR = 'hsl(198, 10%, 46%)';
